'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.HideEmptyRowItemsSelect = undefined;

var _Style = require('./Style');

var _Style2 = _interopRequireDefault(_Style);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var HideEmptyRowItemsSelect = function HideEmptyRowItemsSelect(refs) {
    var i18n = refs.i18nManager.get();

    return Ext.create('Ext.form.field.ComboBox', {
        cls: 'ns-combo',
        style: 'margin-bottom:' + _Style2.default.comboBottomMargin + 'px',
        width: _Style2.default.cmpWidth,
        labelWidth: _Style2.default.labelWidth,
        fieldLabel: i18n.hide_empty_categories,
        labelSeparator: null,
        labelStyle: 'color:#333',
        queryMode: 'local',
        valueField: 'id',
        editable: false,
        value: 'NONE',
        store: Ext.create('Ext.data.Store', {
            fields: ['id', 'text'],
            data: [{ id: 'NONE', text: i18n.none }, { id: 'BEFORE_FIRST', text: i18n.before_first }, { id: 'AFTER_LAST', text: i18n.after_last }, { id: 'BEFORE_FIRST_AFTER_LAST', text: i18n.before_first_after_last }, { id: 'ALL', text: i18n.all }]
        })
    });
};

exports.HideEmptyRowItemsSelect = HideEmptyRowItemsSelect;
exports.default = HideEmptyRowItemsSelect;
//# sourceMappingURL=HideEmptyRowItems.js.map


/*****************
 ** WEBPACK FOOTER
 ** ./~/d2-analysis/lib/ui/options/HideEmptyRowItems.js
 ** module id = 354
 ** module chunks = 0
 **/